import React, { Component } from "react";

class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minutes: this.props.minutes,
      seconds: "00"
    };
    this.secondsRemaining;
    this.intervalHandle;
    this.tick = this.tick.bind(this);
  }

  componentWillMount() {
    this.intervalHandle = setInterval(this.tick, 1000);
    let time = this.props.minutes;
    this.secondsRemaining = time * 60;
  }

  tick() {
    var min = Math.floor(this.secondsRemaining / 60);
    var sec = this.secondsRemaining - min * 60;
    this.setState({
      minutes: min,
      seconds: sec
    });
    if (sec < 10) {
      this.setState({
        seconds: "0" + this.state.seconds
      });
    }
    if (min < 10) {
      this.setState({
        value: "0" + min
      });
    }
    if ((min === 0) & (sec === 0)) {
      clearInterval(this.intervalHandle);
    }
    this.secondsRemaining--;
  }

  render() {
    return (
      <div className="">
        {this.state.minutes}:{this.state.seconds}
      </div>
    );
  }
}

export default Timer;



// WEBPACK FOOTER //
// ./src/components/Timer/index.js